import Image from 'next/image';
import React from 'react';

import Logo from '@/assets/vb-map-mini-logo.svg';

const LogoAnimate = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="animate-bounce">
        <Image src={Logo} alt="Venture Builder Map Logo" />
      </div>
    </div>
  );
};

export default LogoAnimate;
